import React from 'react';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import { DialogBreadcrumbsProps, Breadcrumb, BreadcrumbLevel } from './DialogBreadcrumbs.types';
import TooltipOne from '../TooltipOne/TooltipOne.component';
import { useStyles } from './DialogBreadcrumbs.styles';

export const DialogBreadcrumbs: React.FC<DialogBreadcrumbsProps> = (props) => {
  const { id, level, session, changeHandler, sessionItems } = props;
  const [dropdownAnchorElement, setDropdownAnchorElement] = React.useState<SVGSVGElement | null>(null);

  const buildBreadcrumbs = React.useMemo((): { dropdown: Breadcrumb[]; breadcrumbs: Breadcrumb[] } => {
    const breadcrumbs: Breadcrumb[] = [
      {
        id: session.id,
        name: session.name,
        level: BreadcrumbLevel.SESSION,
      },
    ];

    switch (level) {
      case BreadcrumbLevel.EXAM: {
        const exam = sessionItems.exam;
        if (exam) {
          breadcrumbs.push({
            id: exam.id,
            name: exam.name ? exam.name : 'Zdefiniuj egzamin',
            level: BreadcrumbLevel.EXAM,
          });
        }
        break;
      }
      case BreadcrumbLevel.EXAMSHEET: {
        const exam = sessionItems.exam;
        if (exam) {
          breadcrumbs.push({
            id: exam.id,
            name: exam.name,
            level: BreadcrumbLevel.EXAM,
          });
        }
        const sheet = sessionItems.examSheet;
        if (sheet) {
          breadcrumbs.push({
            id: sheet.id,
            name: sheet.name && sheet.code ? `${sheet.name}-${sheet.code}` : 'Zdefiniuj arkusz',
            level: BreadcrumbLevel.EXAMSHEET,
          });
        }
        break;
      }
      case BreadcrumbLevel.TASKGROUP: {
        const exam = sessionItems.exam;
        if (exam) {
          breadcrumbs.push({
            id: exam.id,
            name: exam.name,
            level: BreadcrumbLevel.EXAM,
          });
        }
        const sheet = sessionItems.examSheet;
        if (sheet) {
          breadcrumbs.push({
            id: sheet.id,
            name: `${sheet.code}-${sheet.name}`,
            level: BreadcrumbLevel.EXAMSHEET,
          });
        }
        const group = sessionItems.taskGroup;
        if (group) {
          breadcrumbs.push({
            id,
            name: group.name ? group.name : 'Zdefiniuj grupę zadań',
            level: BreadcrumbLevel.TASKGROUP,
          });
        }
        break;
      }
      case BreadcrumbLevel.TASK: {
        const exam = sessionItems.exam;
        if (exam) {
          breadcrumbs.push({
            id: exam.id,
            name: exam.name,
            level: BreadcrumbLevel.EXAM,
          });
        }
        const sheet = sessionItems.examSheet;
        if (sheet) {
          breadcrumbs.push({
            id: sheet.id,
            name: `${sheet.code}-${sheet.name}`,
            level: BreadcrumbLevel.EXAMSHEET,
          });
        }
        const group = sessionItems.taskGroup;

        if (group) {
          breadcrumbs.push({
            id: group.id,
            name: group.name,
            level: BreadcrumbLevel.TASKGROUP,
          });
        }
        const task = sessionItems.task;

        if (task) {
          breadcrumbs.push({
            id,
            name: task.taskNumber ? `Zadanie ${task.taskNumber}` : 'Zdefiniuj zadanie',
            level: BreadcrumbLevel.TASK,
          });
        }
        break;
      }
      case BreadcrumbLevel.GRADERULES: {
        const exam = sessionItems.exam;
        if (exam) {
          breadcrumbs.push({
            id: exam.id,
            name: exam.name,
            level: BreadcrumbLevel.EXAM,
          });
        }
        const sheet = sessionItems.examSheet;
        if (sheet) {
          breadcrumbs.push({
            id: sheet.id,
            name: `${sheet.code}-${sheet.name}`,
            level: BreadcrumbLevel.EXAMSHEET,
          });
        }
        const group = sessionItems.taskGroup;
        if (group) {
          breadcrumbs.push({
            id: group.id,
            name: group.name,
            level: BreadcrumbLevel.TASKGROUP,
          });
        }
        const task = sessionItems.task;
        if (task) {
          breadcrumbs.push({
            id: task.id,
            name: `Zadanie ${task.taskNumber}`,
            level: BreadcrumbLevel.TASK,
          });
        }
        const rules = sessionItems.gradeRules;
        if (rules) {
          breadcrumbs.push({
            id,
            name: rules.schemas && rules.schemas.length ? 'Zasady oceniania' : 'Zdefiniuj zasady oceniania',
            level: BreadcrumbLevel.GRADERULES,
          });
        }
        break;
      }
      case BreadcrumbLevel.CRITERIA_SETUP: {
        const exam = sessionItems.exam;
        if (exam) {
          breadcrumbs.push({
            id: exam.id,
            name: exam.name,
            level: BreadcrumbLevel.EXAM,
          });
        }
        const sheet = sessionItems.examSheet;
        if (sheet) {
          breadcrumbs.push({
            id: sheet.id,
            name: `${sheet.code}-${sheet.name}`,
            level: BreadcrumbLevel.EXAMSHEET,
          });
        }
        const group = sessionItems.taskGroup;
        if (group) {
          breadcrumbs.push({
            id: group.id,
            name: group.name,
            level: BreadcrumbLevel.TASKGROUP,
          });
        }
        const task = sessionItems.task;
        if (task) {
          breadcrumbs.push({
            id: task.id,
            name: `Zadanie ${task.taskNumber}`,
            level: BreadcrumbLevel.TASK,
          });
        }
        breadcrumbs.push({
          id,
          name: 'Kryteria zależne',
          level: BreadcrumbLevel.CRITERIA_SETUP,
        });
        break;
      }

      case BreadcrumbLevel.SCHEMA: {
        const exam = sessionItems.exam;
        if (exam) {
          breadcrumbs.push({
            id: exam.id,
            name: exam.name,
            level: BreadcrumbLevel.EXAM,
          });
        }
        const sheet = sessionItems.examSheet;

        if (sheet) {
          breadcrumbs.push({
            id: sheet.id,
            name: `${sheet.code}-${sheet.name}`,
            level: BreadcrumbLevel.EXAMSHEET,
          });
        }
        const group = sessionItems.taskGroup;
        if (group) {
          breadcrumbs.push({
            id: group.id,
            name: group.name,
            level: BreadcrumbLevel.TASKGROUP,
          });
        }
        const task = sessionItems.task;
        if (task) {
          breadcrumbs.push({
            id: task.id,
            name: `Zadanie ${task.taskNumber}`,
            level: BreadcrumbLevel.TASK,
          });
        }
        const rules = sessionItems.gradeRules;
        if (rules) {
          breadcrumbs.push({
            id: rules.id,
            name: 'Zasady oceniania',
            level: BreadcrumbLevel.GRADERULES,
          });
        }
        const schema = sessionItems.schemeScores;
        if (schema) {
          breadcrumbs.push({
            id,
            name: schema.number ? `Schemat punktowania ${schema.number}` : 'Zdefiniuj schemat punktowania',
            level: BreadcrumbLevel.SCHEMA,
          });
        }
        break;
      }
      default:
        break;
    }

    if (breadcrumbs.length < 5) {
      setDropdownAnchorElement(null);
    }

    return {
      dropdown: breadcrumbs.length > 4 ? breadcrumbs.slice(0, breadcrumbs.length - 4) : [],
      breadcrumbs: breadcrumbs.slice(-4),
    };
  }, [id, level, session, sessionItems]);

  const styles = useStyles();

  const handleClickDropdown = (event: React.MouseEvent<SVGSVGElement, MouseEvent>) => {
    setDropdownAnchorElement(event.currentTarget);
  };

  const handleCloseDropdown = () => {
    setDropdownAnchorElement(null);
  };

  return (
    <div className={styles.breadcrumbs}>
      {buildBreadcrumbs.dropdown.length > 0 && (
        <>
          <MoreHorizIcon
            className={styles.dropdown}
            onClick={handleClickDropdown}
            aria-controls="breadcrumbsDropdown-menu"
            aria-haspopup="true"
          />
          <Menu
            id="breadcrumbsDropdown-menu"
            keepMounted
            anchorEl={dropdownAnchorElement}
            open={Boolean(dropdownAnchorElement)}
            onClose={handleCloseDropdown}
          >
            {buildBreadcrumbs.dropdown.map((breadcrumb) => (
              <MenuItem
                disableRipple
                key={`dropdown-${breadcrumb.id}`}
                onClick={() => changeHandler(breadcrumb.level, breadcrumb.id)}
              >
                {breadcrumb.name}
              </MenuItem>
            ))}
          </Menu>
        </>
      )}
      {buildBreadcrumbs.breadcrumbs.map((breadcrumb, index) => (
        <div key={`breadcrumbs-${breadcrumb.id}`} className={styles.breadcrumb}>
          <span onClick={() => changeHandler(breadcrumb.level, breadcrumb.id)}>
            {((buildBreadcrumbs.dropdown.length === 0 && index > 0) || buildBreadcrumbs.dropdown.length > 0) && (
              <span className={styles.breadcrumbSeparator}>/</span>
            )}
            <TooltipOne title={breadcrumb.name} placement="top">
              <span>{breadcrumb.name}</span>
            </TooltipOne>
          </span>
        </div>
      ))}
    </div>
  );
};
